var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconTorquecheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30.000000pt",
    height: "25.000000pt",
    viewBox: "0 0 162.000000 132.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,132.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890 1259 c-234 -75 -256 -85 -281 -126 -20 -31 -20 -45 -17 -251 3 -205 5 -221 30 -291 47 -128 127 -229 250 -312 74 -50 195 -109 225 -109 39 0 141 47 228 105 151 100 247 235 280 390 10 47 15 131 15 255 0 163 -2 188 -19 213 -10 15 -27 34 -37 41 -28 20 -431 146 -462 145 -15 0 -110 -27 -212 -60z m416 -121 l194 -62 0 -167 c0 -188 -9 -246 -51 -336 -39 -82 -149 -185 -261 -243 l-82 -43 -85 43 c-105 54 -215 155 -255 233 -47 94 -56 147 -56 338 l0 176 188 60 c103 34 193 62 201 62 7 1 100 -27 207 -61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169 843 l-118 -116 -50 46 c-28 26 -54 47 -59 47 -5 0 -21 -9 -36 -21 -43 -34 -35 -62 41 -140 98 -101 95 -102 271 74 112 112 142 148 142 169 0 27 -31 58 -59 58 -8 0 -67 -52 -132 -117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 588 c-157 -88 -156 -88 -156 -258 0 -169 0 -170 149 -254 68 -38 132 -71 144 -73 29 -5 275 135 293 168 20 35 19 297 -1 325 -17 25 -257 164 -283 164 -9 0 -75 -33 -146 -72z m241 -161 c29 -28 37 -45 41 -85 14 -155 -191 -211 -260 -72 -51 101 22 207 135 197 40 -3 56 -11 84 -40z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTorquecheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-torquecheck.b38a1e84.svg";
export { ForwardRef as ReactComponent };